import * as React from "react";

import { Context } from "../Context";

export function ExperienceContent(props: any) {
  const context: any = React.useContext(Context);
  let itemMap = [];
  if (Array.isArray(props.items) && props.items.length > 0) {
    itemMap = props.items.map((item: any, index: number) => {
      return (
        <li key={index} className="experience">
          {item.logo && <div className="logo xx" style={{ backgroundImage: `url('${item.logo}')` }} />}
          <p className="dates">
            {item.start} {item.end && " to "} {item.end}
          </p>
          <h4>{item.company}</h4>
          <h5>{item.role}</h5>
          {item.descriptionList && (
            <ul className="description">
              {item.descriptionList.map((li: any, index: number) => {
                return <li key={index}>{li}</li>;
              })}
            </ul>
          )}
        </li>
      );
    });
    return <ul>{itemMap}</ul>;
  }
  return null;
}
